<template>
  <div class="row">
    <div class="col-md-12">
      <div class="info-table" style="justify-content: flex-end">
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="busca-ativa"
          >
          </download-files>
        </div>
      </div>
      <TabelaCadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      />
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'
import TabelaCadastros from './TabelaCadastros.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'BuscaAtiva',
  components: {
    TabelaCadastros,
    DownloadFiles,
  },
  mixins: [utils],

  data() {
    return {
      cadastros: [],
      loading: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    async buscarDadosBuscaAtiva() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (user) {
          let response = await this.$api.get(
            '/app/busca-ativa/acs/' +
              this.$store.state.cod_ibge +
              '/' +
              user.data.cpf
          )
          this.cadastros = []
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, '', {
        no_profissional: this.$store.state.username,
      })
    },

    init() {
      this.buscarDadosBuscaAtiva()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
